module.exports = __webpack_public_path__ + "img/mini-logo.a1b08b38.png";